import Swiper from "swiper";
import {Tracking} from "../../tracking/tracking";

/**
 * Product swiper on  blog entry pages (.swiper-products)
 */
export class TeaserSlider {
  private readonly swiperDiv: HTMLDivElement;

  constructor(swiperDiv: HTMLDivElement) {
    this.swiperDiv = swiperDiv;
    this.initSwiper();
  }

  private initSwiper() {
    // Define how many slides are shown, depending on screen width / breakpoints
    const slidesPerView = [1.6, 2.6, 4, 4, 4];

    const swParams = {
      breakpoints: {
        480: {
          slidesOffsetBefore: 16,
          slidesPerView: slidesPerView[0],
        },
        767: {
          slidesOffsetBefore: 16,
          slidesPerView: slidesPerView[1],
        },
        940: {
          slidesOffsetBefore: 0,
          slidesPerView: slidesPerView[2],
        },
        1119: {
          slidesOffsetBefore: 0,
          slidesPerView: slidesPerView[3],
        },
      },
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 3,
      },
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      observer: true,
      on: {
        init,
        slideChange,
      },
      preloadImages: false,
      slidesOffsetBefore: 0,
      slidesPerView: slidesPerView[4],
      spaceBetween: 16,
    };

    const _ = new Swiper(this.swiperDiv, swParams);
    _.loaded = true;
  }
}

function init() {
  Array.from<HTMLDivElement>(this.slides).forEach((slide) => {
    const anchor = slide.querySelector("a") as HTMLAnchorElement;
    anchor.addEventListener("click", (evt: Event) => {
      Tracking.sendEvent("BlogEntry.ProductSwiper.Slide.Clicked");
    });
  });
}

function slideChange() {
  if (this.loaded) {
    Tracking.sendEvent("BlogEntry.ProductSwiper.Swiped");
  }
}
